<template>

    <div class="layout__container">

        <div class="layout__width-80 layout__padding-clear">
            <div class="layout__padding-20px">

                <div class="layout__position-left layout__width-100 layout__padding__top-20px">
                    <h2 class="text__align-center text__colour-teal layout__margin__top-10">Customer Search</h2>
                    <CustomerSearch v-bind:searchParams="searchParams" v-bind:customers="customers"
                                    v-bind:loading="loading" v-bind:resultsCount="resultsCount"></CustomerSearch>
                </div>

                <div>
                    <el-table :data="customers" width="100%" v-on:row-click="viewCustomers"
                              v-loading.fullscreen.lock="loading">
                        <el-table-column prop="ref" label="Branch" width="100">
                        </el-table-column>
                        <el-table-column prop="parentRef" label="Head Office" width="100">
                        </el-table-column>
                        <el-table-column prop="status" label="Status" width="100">
                        </el-table-column>
                        <el-table-column prop="type" label="Type" width="150">
                        </el-table-column>
                        <el-table-column prop="customerName" label="Customer" width="300">
                        </el-table-column>
                        <el-table-column prop="branchName" label="Branch Name" width="300">
                        </el-table-column>
                        <el-table-column prop="town" label="Town" width="200">
                        </el-table-column>
                        <el-table-column prop="postcode" label="Postcode" width="100">
                        </el-table-column>
                        <el-table-column prop="brand" label="Brand" width="300">
                        </el-table-column>
                    </el-table>

                </div>
                <div class="layout__padding-clear layout__width-60">
                    <div class="layout__padding-20-0">
                        <el-pagination class=""
                                       @size-change="handleSizeChange"
                                       @current-change="handleCurrentChange"
                                       :current-page="this.searchParams.currentPage"
                                       :page-sizes="[20, 40, 60, 80, 100]"
                                       :page-size="this.searchParams.pagination"
                                       layout="total, sizes, prev, pager, next, jumper"
                                       :total="this.resultsCount">
                        </el-pagination>
                    </div>
                </div>

            </div>
        </div>
    </div>

</template>

<script>

    import CustomerSearch from '../../components/search/CustomerSearch.vue';
    import Pagination from "../../components/Pagination";
    import {pagination} from '@/mixins/Pagination.js';

    export default {
        name: "customers",
        mixins: [pagination],
        props: {
            view: ''
        },
        components: {
            CustomerSearch,
            Pagination
        },
        data() {
            return {
                resultsCount: '',
                customers: [],
                searchParams: {
                    freetext: '',
                    status: 'ACTIVE',
                    top: 20,
                    pagination: 20,
                    skip: 0,
                },
                loading: false,
                exportDate: new Date().toLocaleDateString('en-GB') + '_customers.csv',
            }
        },
        beforeUpdate() {
            window.sessionStorage.setItem('_customersSearch', JSON.stringify(this.searchParams));
        },
        methods: {
            viewCustomers(customer) {
                this.$router.push({
                    name: '/billing/customers/details',
                    params: {
                        customer: customer
                    },
                    query: {
                        ref: customer.ref,
                    }
                })
            },
            something() {
                const fields = [
                    {label: 'Id', value: 'id'},
                    {label: 'Branch', value: 'ref'},
                    {label: 'Head_Office', value: 'parentRef'},
                    {label: 'Netsuite_Id', value: 'netsuiteId'},
                    {label: 'Status', value: 'status'},
                    {label: 'Type', value: 'type'},
                    {label: 'Customer', value: 'customerName'},
                    {label: 'Branch_Name', value: 'branchName'},
                    {label: 'Address1', value: 'address1'},
                    {label: 'Address2', value: 'address2'},
                    {label: 'Address3', value: 'address3'},
                    {label: 'Town', value: 'town'},
                    {label: 'County', value: 'county'},
                    {label: 'Postcode', value: 'postcode'},
                    {label: 'DX', value: 'box'},
                    {label: 'Print_Profile', value: 'printProfile'},
                    {label: 'Territory', value: 'territory'},
                    {label: 'Brand', value: 'brand'},
                    {label: 'Software', value: 'software'},
                    {label: 'Accounts_Email', value: 'accountsEmail'},
                    {label: 'Vat_Rate', value: 'vatRate'},
                    {label: 'Invoice_Flag', value: 'invoiceFlag'},
                    {label: 'Sage_Status', value: 'sageStatus'},
                    {label: 'Last_Order', value: 'lastOrder'},
                ];

                this.downloadCsv(this.exportDate, fields, this.orders)

            },
            resultsPerPage() {
                document.getElementById('getCustomersPagination').click()

            },
            csv() {
                document.getElementById('downloadAllResults').click()
            }
        },
        created() {
            this.isUserAuthorised();
            console.log(this.view)
        }
    };
</script>